import Swal from "sweetalert2";

import type { SweetAlertResult } from "sweetalert2";

/**
 * Deja de reportar "problema interno" cuando ya se sabe que la causa fue la sesión vencida.
 *
 * sweetalert2 muestra un modal por vez, así que sin esto el `ErrorServer()` con el que cada
 * módulo termina su promesa rechazada le pisaría el aviso de sesión vencida al colaborador,
 * que es justo el mensaje equivocado del que veníamos. Es un latch de una sola dirección a
 * propósito: el interceptor recarga la página enseguida y eso lo devuelve a su estado inicial.
 */
let serverErrorPopupsSuppressed = false;

export const suppressServerErrorPopups = (): void => {
    serverErrorPopupsSuppressed = true;
};

/** Vuelve a habilitarlos. La app no lo necesita — recarga — pero deja el latch verificable. */
export const restoreServerErrorPopups = (): void => {
    serverErrorPopupsSuppressed = false;
};

/** Resultado neutro para quien esté esperando el popup que se decidió no mostrar. */
const dismissedResult: SweetAlertResult = { isConfirmed: false, isDenied: false, isDismissed: true };

export const ErrorServer = (): Promise<SweetAlertResult> => {
    if (serverErrorPopupsSuppressed) {
        return Promise.resolve(dismissedResult);
    }

    return Swal.fire('Error',
        'Hubo Un Problema Interno',
        'error')
};

export const SuccessAlert = (title: string, message?: string): Promise<SweetAlertResult> => {
    return Swal.fire(title,
        message,
        'success')
}

export const InfoAlert = (title: string, message?: string): Promise<SweetAlertResult> => {
    return Swal.fire(title,
        message,
        'info')
}

export const ErrorAlert = (title: string, message?: string): Promise<SweetAlertResult> => {
    return Swal.fire(title,
        message,
        'error')
}

export const WarningAlert = (title: string, message?: string): Promise<SweetAlertResult> => {
    return Swal.fire(title,
        message,
        'warning')
}

export const WarningAlertCustom = (title: string, html: string): Promise<SweetAlertResult> => {
    return Swal.fire({
        title: title,
        html: html,
        icon: "warning",
    })
}

